import React from 'react';
import AssetPage from '@/app/pages/asset-detail';
import AuditorContextProvider from '../components/AuditorContextProvider';
import { useNavigate } from 'react-router-dom';

/**
 * Auditor Asset Detail component
 * 
 * Renders a read-only version of the Asset Detail page for auditor view
 * We use AuditorContextProvider to get the context providers but avoid duplicate headers
 */
const AuditorAssetDetail: React.FC = () => {
  const navigate = useNavigate();

  // Create a navigation handler for back button
  const handleBackNavigation = () => {
    // Always navigate to auditor asset register
    navigate('/auditor-view/asset-register');
  };

  return (
    <AuditorContextProvider>
      {/* Pass the custom back navigation handler to asset page */}
      <AssetPage 
        isReadOnly={true}
        onBackNavigation={handleBackNavigation} 
      />
    </AuditorContextProvider>
  );
};

export default AuditorAssetDetail;
